export default {
    data() {
        return {
            componentActiveClass: "component-active"
        };
    },
    methods: {
        __setActiveClass(component, state = true) {
            const element = document.querySelector(`[data-container-ref='${component}']`);

            if (element) {
                if (state) {
                    element.classList.add(this.componentActiveClass);
                } else if (element.classList.contains(this.componentActiveClass)) {
                    element.classList.remove(this.componentActiveClass);
                }
            }
        },
        __clearActiveClass() {
            const elements = document.querySelectorAll(`.${this.componentActiveClass}`);
            if (elements && elements.length) {
                elements.forEach(element => element.classList.remove(this.componentActiveClass));
            }
        }
    }
};
